/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "zile",
                  "zile",
                  "zile",
                  "zile",
                  "zile"
            ],
            "plural": [
                  "de zile",
                  "de zile",
                  "de zile",
                  "de zile",
                  "de zile"
            ],
            "singular": [
                  "zi",
                  "zi",
                  "zi",
                  "zi",
                  "zi"
            ]
      },
      "hour": {
            "few": [
                  "ore",
                  "ore",
                  "ore",
                  "ore",
                  "ore"
            ],
            "plural": [
                  "de ore",
                  "de ore",
                  "de ore",
                  "de ore",
                  "de ore"
            ],
            "singular": [
                  "oră",
                  "oră",
                  "oră",
                  "oră",
                  "oră"
            ]
      },
      "minute": {
            "few": [
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute"
            ],
            "plural": [
                  "de minute",
                  "de minute",
                  "de minute",
                  "de minute",
                  "de minute"
            ],
            "singular": [
                  "minut",
                  "minut",
                  "minut",
                  "minut",
                  "minut"
            ]
      },
      "month": {
            "few": [
                  "luni",
                  "luni",
                  "luni",
                  "luni",
                  "luni"
            ],
            "plural": [
                  "de luni",
                  "de luni",
                  "de luni",
                  "de luni",
                  "de luni"
            ],
            "singular": [
                  "lună",
                  "lună",
                  "lună",
                  "lună",
                  "lună"
            ]
      },
      "second": {
            "few": [
                  "secunde",
                  "secunde",
                  "secunde",
                  "secunde",
                  "secunde"
            ],
            "plural": [
                  "de secunde",
                  "de secunde",
                  "de secunde",
                  "de secunde",
                  "de secunde"
            ],
            "singular": [
                  "secundă",
                  "secundă",
                  "secundă",
                  "secundă",
                  "secundă"
            ]
      },
      "year": {
            "few": [
                  "ani",
                  "ani",
                  "ani",
                  "ani",
                  "ani"
            ],
            "plural": [
                  "de ani",
                  "de ani",
                  "de ani",
                  "de ani",
                  "de ani"
            ],
            "singular": [
                  "an",
                  "an",
                  "an",
                  "an",
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
